module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/1@2x_3955ed03d9b6aea61d675887d81601e1.png";